"use client";

import { clsx } from "clsx";
import { useTranslations } from "next-intl";
import { fieldLabelClassname } from "./field-variants";

const optionalTagClassname = "tw-text-[0.75rem] tw-text-black tw-opacity-40";

type FieldLabelProps = {
  label: React.ReactNode;
  htmlFor: string;
  required?: boolean;
  accessory?: React.ReactNode;
  layout?: "default" | "checkbox";
  showTestVariant?: boolean;
};

export function FieldLabel({
  label,
  htmlFor,
  required,
  accessory,
  layout = "default",
  showTestVariant = false,
}: FieldLabelProps) {
  const t = useTranslations("ClientKeys.contact_sales_page.form");

  const showAsterisk = showTestVariant && required;
  const showOptionalTag = !showTestVariant && !required;

  if (layout === "checkbox") {
    return (
      <label htmlFor={htmlFor} className='tw-type-2xs tw-text-black/60 tw-p-0.5 tw-cursor-pointer tw-mb-1'>
        {label}
        {showAsterisk && <span aria-hidden='true'>*</span>}
        {showOptionalTag && <span className={optionalTagClassname}> ({t("labels.optional")})</span>}
      </label>
    );
  }

  return (
    <div className={clsx("tw-flex tw-justify-between tw-mb-1", accessory && "tw-items-center")}>
      <div className={clsx(accessory && "tw-flex tw-items-center tw-gap-2")}>
        <label className={fieldLabelClassname} htmlFor={htmlFor}>
          {label}
          {showAsterisk && <span aria-hidden='true'>*</span>}
        </label>
        {accessory}
      </div>
      {showOptionalTag && <span className={optionalTagClassname}>{t("labels.optional")}</span>}
    </div>
  );
}
